import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import Colors from '@components/shared/Colors';
import useReplacedInnerHtml from '@utils/useReplacedInnerHtml';

interface Props {
  align: string;
  item: {
    key: string;
    icon: any;
  };
}
const VMSVaginalFloraItem: React.FC<Props> = ({ item, align }) => {
  const { t } = useTranslation();
  const descriptionRef = useReplacedInnerHtml(t(`${item.key}.description`));

  return (
    <IconBox key={item.key} $align={align}>
      <IconFrame>
        <item.icon />
      </IconFrame>
      <TextBox $align={align}>
        <Heading>{t(`${item.key}.title`)}</Heading>
        <Description ref={descriptionRef} />
      </TextBox>
    </IconBox>
  );
};

export default VMSVaginalFloraItem;

const IconBox = styled.div<{ $align: string }>`
  text-align: ${(props) => props.$align ?? 'center'};
  align-items: ${(props) => (props.$align === 'left' ? 'flex-start' : 'flex-end')};
  display: flex;
  flex-direction: column;
  padding: 0;
  gap: 5px;
  color: ${Colors.navyBlue};

  & > svg {
    margin-bottom: 15px;
    width: 70px;
  }

  & > h3 {
    text-align: inherit;
    text-transform: uppercase;
  }

  @media (max-width: 1024px) {
    align-items: flex-start;
    flex-direction: row;
  }
`;

const Description = styled.span`
  font-family: BrownStd;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0;
  text-align: inherit;

  @media (max-width: 1024px) {
    font-size: 13px;
    line-height: 150%;
    text-align: left;
  }
`;

const TextBox = styled.div<{ $align: string }>`
  display: flex;
  flex-direction: column;
  align-items: ${(props) => (props.$align === 'left' ? 'flex-start' : 'flex-end')};
  padding: 0px;
  gap: 5px;

  @media (max-width: 1024px) {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-left: 20px;
    padding: 0;
  }
`;

const IconFrame = styled.div`
  width: 70px;
  height: 70px;
  flex: none;
  order: 0;
  flex-grow: 0;

  @media (max-width: 1024px) {
    width: 50px;
    height: 50px;
    align-items: flex-start;
    display: flex;
  }
`;

export const Heading = styled.h3`
  font-family: BrownStd;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 1.5px;
  text-align: center;
  text-transform: uppercase;
  @media (max-width: 1024px) {
    text-align: left;
  }
`;
